<div class="actions-container">
  <button mat-button color="primary" (click)="handleSaveOrder()">Salva ordinamento</button>
  <button
    style="margin-left:10px;"
    mat-button
    mat-raised-button
    color='primary'
    (click)="exportSelected()">
    Seleziona ed esporta
  </button>
</div>


<mat-table
  #table
  [dataSource]="dataSource"
  class="mat-elevation-z8"
  cdkDropList
  (cdkDropListDropped)="drop($event)"
  cdkDropListData="dataSource"
  [cdkDropListDisabled]="dragDisabled"
>
  <!--- Note that these columns can be defined in any order.
        The actual rendered columns are set as a property on the row definition" -->

  <!-- Position Column -->
  <ng-container matColumnDef="position" sticky>
    <mat-header-cell *matHeaderCellDef> No.</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <mat-icon class="dragCursor" (mousedown)="dragDisabled = false;"
      >reorder
      </mat-icon
      >
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="img">
    <mat-header-cell *matHeaderCellDef> img</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <img style="max-width: 60%;" loading="lazy" [src]="fileUrl+element.img"></mat-cell>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="titolo">
    <mat-header-cell *matHeaderCellDef>titolo</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.titolo }}</mat-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="materiale">
    <mat-header-cell *matHeaderCellDef>materiale</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.materiale }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="misure">
    <mat-header-cell *matHeaderCellDef>misure</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ element.misure }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="peso">
    <mat-header-cell *matHeaderCellDef>peso</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.peso }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="anno">
    <mat-header-cell *matHeaderCellDef>anno</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.anno }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="base">
    <mat-header-cell *matHeaderCellDef>base</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.base }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="misure-base">
    <mat-header-cell *matHeaderCellDef>misure base</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.misureBase }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="materiale-base">
    <mat-header-cell *matHeaderCellDef>materiale base</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.materialeBase }}</mat-cell>
  </ng-container>


  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell class="table-actions-cell" *matCellDef="let element">
      <ng-container *ngIf="isCompactActions; else fullActions">
        <button
          mat-icon-button
          color="primary"
          [matMenuTriggerFor]="actionsMenu"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="handleEdit(element)">
            <mat-icon>edit</mat-icon>
            <span>Modifica</span>
          </button>
          <button
            *ngIf="hasCapabilityToDelete"
            mat-menu-item
            (click)="handleDelete(element)">
            <mat-icon>delete</mat-icon>
            <span>Elimina</span>
          </button>
        </mat-menu>
      </ng-container>
      <ng-template #fullActions>
        <button
          mat-icon-button
          color="primary"
          (click)="handleEdit(element)">
          <mat-icon matTooltip="modifica">edit</mat-icon>
        </button>
        <button
          *ngIf="hasCapabilityToDelete"
          mat-icon-button
          color="warn"
          (click)="handleDelete(element)">
          <mat-icon matTooltip="elimina">delete</mat-icon>
        </button>
      </ng-template>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row
    *matRowDef="let row; columns: displayedColumns;"
    cdkDrag
    [cdkDragData]="row"
  ></mat-row>
</mat-table>
